import Vue from 'vue';
import Vuex from 'vuex';

import { auth } from './auth';
import { company } from './company/company';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    auth,
    company,
  },
});
